import { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { plural, t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Alert, Box, Button, Loader, TeamAvatar, Typography, UserAvatar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SearchableMenu, SearchableMenuMultiSelectList } from 'shared/domains/common-ui/SearchableMenu';
import { SelectVoluntaryApproversDocument } from './SelectManualApprovers.gql';
import { normalizeItems } from './normalizeItems';
import { useWorkflowApprovers } from '../../WorkflowApproversProvider';
export function SelectManualApprovers() {
    const { selectedApproverIds, toggleApprover } = useWorkflowApprovers();
    const [open, setOpen] = useState(false);
    const { data, loading, error } = useQuery(SelectVoluntaryApproversDocument, { skip: !open });
    const { teams, users } = normalizeItems(data);
    const selectedIds = selectedApproverIds;
    const toggleMenu = () => setOpen(true);
    const closeMenu = () => setOpen(false);
    const getMembersAmount = (members = 0) => plural(members, {
        0: 'No members',
        one: '# member',
        other: '# members',
    });
    if (error) {
        return (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please reload the page and try again',
                comment: 'Document approval check - select approvers field - failed to load data to display',
            })}/>);
    }
    return (<SearchableMenu open={open} keys={['name', 'email']} items={[...teams, ...users]} onClose={closeMenu} groups={[
            { id: 'user', name: t({ message: 'Teams', comment: 'Select approvers - Teams group label' }) },
            { id: 'team', name: t({ message: 'Users', comment: 'Select approvers - Users group label' }) },
        ]} itemGroupKey="type" renderTarget={<Button $stretch size="small" appearance="ghost" onClick={toggleMenu}>
          <Falcon icon="plus"/>
          <Trans comment="Select approvers - Add approvers button label">Add approvers</Trans>
        </Button>}>
      {loading && (<Box p="lg" flexDirection="column" alignItems="center">
          <Loader size="sm"/>
          <Typography $fontSize="small" $appearance="100">
            <Trans comment="Select approvers - Loading label">Loading approvers...</Trans>
          </Typography>
        </Box>)}

      {!loading && (<SearchableMenuMultiSelectList selected={selectedIds} onSelect={toggleApprover} renderItem={(item) => {
                var _a;
                if (item.type === 'team') {
                    return <TeamAvatar size="sm" title={item.name} subtitle={getMembersAmount((_a = item.members) === null || _a === void 0 ? void 0 : _a.length)}/>;
                }
                return <UserAvatar size="sm" title={item.name} subtitle={item.email}/>;
            }}/>)}
    </SearchableMenu>);
}
